import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { renderErrorText } from '../Input/renderErrorText.js';
import { Select } from './Select.js';
export const SelectControl = JSX(({ className = '', label, error, ...rest }) => (_jsxs("div", { className: className, children: [_jsx(Select, { ...rest, valid: !error, label: rest?.errors ? `${label}*` : label }), renderErrorText(error)] })));
//# sourceMappingURL=SelectControl.js.map